import { defineGameCard, onAppear } from '../authoring/index.js';
export const WanderingHealerCard = defineGameCard({
    id: 'wandering_healer',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 2, health: 3 } },
    presentation: {
        name: 'Странствующий лекарь',
        description: 'При раскрытии восстановите себе 2 здоровья.',
        glyph: {
            colors: ['#10213A', '#954C30', '#523527', '#AE6E44', '#EFBB84'],
            rows: [
                '....................',
                '........1111........',
                '.......122221.......',
                '.......1233221......',
                '.111..12345321......',
                '.151..12415131..111.',
                '15511.13555532..1511',
                '15555113551532..1551',
                '15551112344332.15551',
                '.141..133553211.1541',
                '.151.22232233221151.',
                '.141112223112222351.',
                '.1213211221321222121',
                '.1223223313132222321',
                '..12212223222311221.',
                '...11.223122331.11..',
                '....12211223331.....',
                '...122221111111.....',
                '...1222222222321....',
                '...1111111111111....',
            ],
        },
    },
    role: 'playable',
    abilities: [onAppear((ctx) => {
            if (ctx.self !== undefined)
                ctx.ops.restorePlayerHealth(ctx.self.controllerId, 2);
        }, { cause: 'played' })],
});
//# sourceMappingURL=wandering_healer.js.map